<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <FormInput label="Nombre" name="descripcion" rules="required" v-model="tipo.descripcion" />
            </div>

            <div class="col-12">
                <div class="form-group">
                    <label for="notas">Descripción Corta <small>Breve descripción, de no más de 2 líneas, que se mostrará en el listado de abonos</small></label>
                    <ValidationProvider id="nota" name="Nota" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Descripción Corta" v-model="tipo.nota"/>
                        <span v-if="errors[0]" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox2" v-model="tipo.renovacion"/>
                    <label for="customCheckbox2" class="custom-control-label">Renovación</label>
                </div>
            </div>
            <div class="col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox5" v-model="tipo.exclusivo_penista"/>
                    <label for="customCheckbox5" class="custom-control-label">Precio para peñistas</label>
                </div>
            </div>
            <div class="col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox3" v-model="tipo.activo"/>
                    <label for="customCheckbox3" class="custom-control-label">Activado</label>
                </div>
            </div>
            <b-col cols="12" class="mt-3">
                <FormPrecioPlazosComponent :data="tipo"/>
            </b-col>
            <b-col cols="12" class="mt-3" v-if="tipo.activar_pago_plazos">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="plazos_abonados_pueden_acceder" v-model="tipo.plazos_abonados_pueden_acceder"/>
                    <label for="plazos_abonados_pueden_acceder" class="custom-control-label">Los abonados con plazos pendientes pueden acceder a los partidos</label>
                </div>
            </b-col>
            <div class="col-12 mt-3">
                <Button type="submit" name="button">Continuar</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import FormPrecioPlazosComponent from '@/components/backend/plazos/FormPrecioPlazosComponent.vue';

    export default {
        props: ['tipo'],
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado');
                }
            }
        },
        components: {
            FormPrecioPlazosComponent
        }
    }
</script>
